import { GetProjectEstimatesQuery } from '@/gql/graphql';
import { Button } from '@payaca/ambrosia';
import { formatPrice } from '@payaca/helpers/financeHelper';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, useState } from 'react';
import BillSavingsExplainedModal from './BillSavingsExplainedModal';

type BillSavingsEstimate = NonNullable<
  GetProjectEstimatesQuery['projectById']['estimates'][number]['billSavingsEstimate']
>;

type BillSavingsSectionProps = {
  billSavingsEstimate: BillSavingsEstimate;
};

const BillSavingsSection: FC<BillSavingsSectionProps> = (props) => {
  const { billSavingsEstimate } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formatWhole = formatPrice(navigator.language, {
    maximumFractionDigits: 0,
  });

  return (
    <div className="md:text-right">
      <div className="mb-2 flex items-center gap-1 md:justify-end">
        <p className="supporting-body font-medium mr-2">Bill savings</p>
        <Button
          variant="link-inline"
          linkColour="dark"
          aria-label="Bill savings explained"
          onClick={() => setIsModalOpen(true)}
        >
          <UntitledIcon name="info-circle.3" className="size-4" />
        </Button>
      </div>
      <div className="flex flex-row gap-4 md:flex-col md:gap-3">
        {billSavingsEstimate.heatPumpCostScenarios.map((scenario, index) => {
          const isNegative = scenario.annualSavings.value < 0;
          const formatted = formatWhole({
            priceInMinorCurrencyUnits: Math.abs(scenario.annualSavings.value),
            exponent: scenario.annualSavings.currency.exponent,
            currencyCode: scenario.annualSavings.currency.code,
          });
          return (
            <div key={index} className="min-w-0 flex-1">
              <p className="supporting-body truncate">{scenario.tariff.name}</p>
              <p className={isNegative ? 'text-red-700' : 'text-green-700'}>
                {isNegative ? `- ${formatted}` : formatted} / year
              </p>
            </div>
          );
        })}
      </div>
      <BillSavingsExplainedModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        billSavingsEstimate={billSavingsEstimate}
      />
    </div>
  );
};

export default BillSavingsSection;
